import "./es.string.trim-6e13db75.js";
import { c as n } from "./index-8b07dec9.js";
import m, { css as d } from "styled-components";
import { a as v } from "./index-5d0f31c6.js";
import { jsxs as h, jsx as a } from "react/jsx-runtime";
import "./export-cdcbfb2b.js";
import "./string-trim-14e37ad3.js";
import "./to-string-92a62764.js";
import "./classof-21a3574e.js";
import "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import "./es.array.concat-d1c9b847.js";
import "./create-property-f9780ed1.js";
import "./object-create-9b6715a2.js";
import "./object-keys-719a5561.js";
import "./html-32ef1b46.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./array-iteration-759bfbfa.js";
import "./es.object.to-string-f55666a8.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./iterate-13ada9e5.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./es.object.assign-7e79fd7b.js";
import "./es.object.keys-9d66766f.js";
import "./object-get-own-property-names-external-2f8b4cc4.js";
import "./array-slice-79f93c56.js";
import "./an-instance-6efcfd6c.js";
import "./check-correctness-of-iteration-7d57c70c.js";
import "./inherit-if-required-f068457b.js";
import "./define-built-in-accessor-26bc7b69.js";
import "./set-species-5ede2ed0.js";
import "./es.string.iterator-5de8a61e.js";
import "./es.string.replace-f4cc3aea.js";
import "./function-apply-4756dee6.js";
import "./web.dom-collections.for-each-3020ed11.js";
import "./array-method-is-strict-e5a3c878.js";
import "@ucl/shared-component-foundations";
import "@ucl/shared-icons";
import "react";
import "./es.array.filter-4e9c9996.js";
import "./es.array.map-d821aaf5.js";
import "./es.object.entries-d2a19275.js";
import "./es.array.is-array-7a29277f.js";
import "./getMetrics-953aa4f8.js";
var o = /* @__PURE__ */ function(e) {
  return e.SUCCESS = "success", e.ERROR = "error", e.CAUTION = "caution", e.NONE = "none", e;
}({}), f = /* @__PURE__ */ m.div.withConfig({
  displayName: "helperText__HelperTextWrapper",
  componentId: "iv9rd-0"
})(["&.HelperText-wrapper{", ";}"], function(e) {
  var r = e.theme.components.helperText;
  return d(r.HelperTextWrapper);
}), y = /* @__PURE__ */ m(v).withConfig({
  displayName: "helperText__StyledIcon",
  componentId: "iv9rd-1"
})(["&.HelperText-icon{", ";}"], function(e) {
  var r = e.theme.components.helperText;
  return d(r.Icon);
}), u = /* @__PURE__ */ m.span.withConfig({
  displayName: "helperText__StyledHelperText",
  componentId: "iv9rd-2"
})(["&.HelperText{", ";}"], function(e) {
  var r = e.theme.components.helperText;
  return d(r.StyledHelperText);
}), Te = function(r) {
  var s, c, p = r.defaultProp, t = r.secondaryProp, x = r.disabled, i = r.inputState, T = !!(p != null && (s = p.helperText) != null && s.trim().length), l = !!(t != null && (c = t.helperText) != null && c.trim().length) && i !== o.NONE;
  return T || l ? /* @__PURE__ */ h(f, {
    onClick: function(H) {
      H.stopPropagation();
    },
    className: n(["HelperText-wrapper", {
      "HelperText-wrapper--secondary": l
    }]),
    children: [T && /* @__PURE__ */ a(u, {
      "data-testid": "helper-text_" + (p == null ? void 0 : p.id),
      id: p.id,
      className: n([["HelperText", "HelperText--default", {
        "HelperText--disabled": x
      }]]),
      children: p.helperText
    }), l && /* @__PURE__ */ h(u, {
      "aria-live": "polite",
      role: "alert",
      "data-testid": "helper-text_" + (t == null ? void 0 : t.id),
      id: t == null ? void 0 : t.id,
      className: n([["HelperText", "HelperText--secondary", "HelperText--" + i, {
        "HelperText--disabled": x
      }]]),
      children: [/* @__PURE__ */ a(y, {
        icon: i === o.ERROR ? "warningFilled" : i === o.SUCCESS ? "checkmarkFilled" : "warning",
        className: "HelperText-icon",
        "aria-label": i === o.ERROR ? "warningFilled" : i === o.SUCCESS ? "checkmarkFilled" : "warning",
        size: "s",
        role: "img"
      }), /* @__PURE__ */ a("span", {
        children: t.helperText
      })]
    })]
  }) : null;
};
export {
  Te as HelperText,
  o as InputState
};
